function getValue (name) {
  switch (window.location.hostname) {
    default:
    case 'localhost':
    case 'developer-beta.noonlight.com':
      switch (name) {
        case 'apiUrl': return 'https://api-beta.noonlight.com/dev-portal/v1'
        case 'prodApiUrl': return undefined
        case 'redirectUri': return 'https://api-beta.noonlight.com/dev-portal/v1/auth/redirect'
        case 'authUrl': return 'https://account-beta.noonlight.com/authorize'
        case 'clientId': return 'zMX3mlj7Y1085qO6LFx3oLBt1e1MS5oK'
        default: throw new Error('Variable out of scope')
      }
    case 'developer.noonlight.com':
      switch (name) {
        case 'apiUrl': return 'https://api.noonlight.com/dev-portal/sandbox/v1'
        case 'prodApiUrl': return 'https://api.noonlight.com/dev-portal/v1'
        case 'redirectUri': return 'https://api.noonlight.com/dev-portal/v1/auth/redirect'
        case 'authUrl': return 'https://account.noonlight.com/authorize'
        case 'clientId': return 'TvzSHepBKNfOkdcDK2plNgOlZUF8IPpI'
        default: throw new Error('Variable out of scope')
      }
  }
}

export default {
  authUrl: getValue('authUrl'),
  apiUrl: getValue('apiUrl'),
  prodApiUrl: getValue('prodApiUrl'),
  redirectUri: getValue('redirectUri'),
  clientId: getValue('clientId')
}
